import { TFunction } from "i18next";
import { QueryKey } from "react-query";
import {
  ICellRendererParams,
  ValueGetterParams,
} from "@ag-grid-community/core";

import {
  getCommonRenderers,
  getCommonColumnDefs,
} from "fe-shared-transactions/src/components/InvoicesDataGrid/modules/config";

import ParticipantRenderer from "../renderers/ParticipantRenderer";
import AssigneeRenderer from "../renderers/AssigneeRenderer";

export const getColumnDefs = (t: TFunction) => {
  const columnDefs = getCommonColumnDefs(t);

  columnDefs.splice(1, 0, {
    headerName: t("invoices.grid.cols.participant"),
    colId: "displayNameOrRegNumber",
    valueGetter: (params: ValueGetterParams) => ({
      participantRegNumber: params.data?.company.regNumber,
      participantDisplayName: params.data?.company.displayName,
    }),
    minWidth: 172,
    cellRenderer: "participantRenderer",
    filter: "textFilter",
    flex: 1,
    filterParams: {
      startFilteringThreshold: 1,
    },
    floatingFilterComponent: "floatingTextFilter",
    floatingFilterComponentParams: {
      placeholder: t("invoices.grid.placeholder.participant"),
      suppressFilterButton: true,
    },
  });

  columnDefs.splice(7, 0, {
    headerName: t("invoices.grid.cols.assignee"),
    colId: "assignedToName",
    valueGetter: (params: ValueGetterParams) => ({
      statusCode: params.data?.statusCode,
      assignee: params.data?.assignee,
    }),
    minWidth: 180,
    cellRenderer: "assigneeRenderer",
    filter: "textFilter",
    floatingFilterComponent: "floatingTextFilter",
    floatingFilterComponentParams: {
      placeholder: t("invoices.grid.placeholder.assignee"),
      suppressFilterButton: true,
    },
  });

  return [
    ...columnDefs,
    {
      hide: true,
      colId: "isPostedToGP",
      filter: "textFilter",
    },
  ];
};

export const getRenderers = (canAssign: boolean, listQueryKey: QueryKey) => ({
  ...getCommonRenderers(),
  participantRenderer: ParticipantRenderer,
  assigneeRenderer: (props: ICellRendererParams) =>
    AssigneeRenderer({ ...props, canAssign, listQueryKey }),
});
